import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

const pageMeta: Record<string, { title: string; description: string }> = {
  "/": {
    title: "Sondermaschinen & Stellplatzausstattung | Ulrich Arzt",
    description:
      "Ulrich Arzt Präzisions-Mechanik Sondermaschinen GmbH in Obertrubach-Geschwand: Sondermaschinen, Edelstahl-Anlagen für Stellplätze und E-Ladestationen.",
  },
  "/produkte": {
    title: "Produkte: Sondermaschinen, Silver-Serie, Ladesäulen | Arzt",
    description:
      "Vorrichtungs- und Sondermaschinenbau, Ver- und Entsorgungsanlagen der Silver-Serie aus Edelstahl sowie Ladestationen für E-Fahrzeuge, E-Bikes und Pedelecs.",
  },
  "/unternehmen": {
    title: "Unternehmen: Familienbetrieb seit 1963 | Ulrich Arzt",
    description:
      "Seit 1963 in Familienhand: Historie, Meilensteine und Maschinenpark der Ulrich Arzt Präzisions-Mechanik Sondermaschinen GmbH in Obertrubach.",
  },
  "/kontakt": {
    title: "Kontakt & Anfahrt Obertrubach-Geschwand | Ulrich Arzt",
    description:
      "Telefon, Telefax, E-Mail und Geschäftszeiten der Ulrich Arzt Präzisions-Mechanik Sondermaschinen GmbH, Geschwand 111 in 91286 Obertrubach.",
  },
  "/impressum": {
    title: "Impressum | Ulrich Arzt Präzisions-Mechanik",
    description:
      "Anbieterkennzeichnung, Registerangaben, Umsatzsteuer-Identifikationsnummer sowie Hinweise zu Haftung und Urheberrecht.",
  },
  "/datenschutz": {
    title: "Datenschutz | Ulrich Arzt Präzisions-Mechanik",
    description:
      "Informationen zur Verarbeitung personenbezogener Daten, zu Kontaktanfragen, Kartendarstellung und zu Ihren Rechten nach DSGVO.",
  },
};

export default function Layout() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const key = pathname !== "/" ? pathname.replace(/\/$/, "") : "/";
    const meta = pageMeta[key] ?? pageMeta["/"];
    document.title = meta.title;

    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "description");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", meta.description);
  }, [pathname]);

  useEffect(() => {
    if (hash) {
      const target = document.getElementById(hash.replace("#", ""));
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}